var map = {
	"./Divij Sharma.jpeg": 2479,
	"./Harshita.jpg": 3136,
	"./Parth_Bhosale.png": 7830,
	"./VEDANT.jpg": 3060,
	"./harshit_k.jpg": 8043,
	"./vasu_BIB.png": 1713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9390;